import "date-fns";
import React, {
  Fragment,
  useReducer,
  useEffect,
  useState,
  forwardRef
} from "react";
import DatePicker from "../../components/Datepicker";
import MaterialSelect from "../../components/MaterialSelect";
import jsPDF from "jspdf";
import "jspdf-autotable";
import api from "../../services/api";
import MaterialTable from "material-table";
import { TextField, Button } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import moment from "moment";
import { TableChart, PictureAsPdf } from "@material-ui/icons";
import { CsvBuilder } from "filefy";
import * as XLSX from 'xlsx';
import PictureAsPdfTwoToneIcon from '@material-ui/icons/PictureAsPdfTwoTone';
import { makeStyles } from '@material-ui/core/styles';

const initialState = {
  load: false,
  companyType: null,
  socialName: null,
  employeeName: null,
  employeeEnable: false,
  onlyExpiredDocument: false,
  companyStatus: "",
  sector: null
};

function reducer(state, { field, value }) {
  return {
    ...state,
    [field]: value
  };
}

const useStyles = makeStyles({
  pdf: {
    marginLeft: "20px",
  },
});

const CompanyReport = () => {
  const classes = useStyles();
  const [state, dispatch] = useReducer(reducer, initialState);
  const [dataCompany, setDataCompany] = useState({
    load: true,
    companyTypes: [],
    companyStatus: [],
    companyData: [],
    companySectors: [],
    columns: [
      { title: "ID", field: "id" },
      { title: "CNPJ", field: "cnpj" },
      { title: "Razão social", field: "socialName" },
      {
        title: "Status",
        field: "status"
      },
      {
        title: "Data de Cadastro",
        field: "createdAt"
      },
      {
        title: "Área gestora",
        field: "sectors"
      }
    ],
    initialDate: null,
    finalDate: null
  });

  const onChange = e => {
    const { name, value } = e.target;
    dispatch({ field: name, value: value });
  };

  const setInitialDate = e => {
    console.log("TCL: setDate -> e", e);
    setDataCompany({ ...dataCompany, initialDate: e });
  };

  const setFinalDate = e => {
    console.log("TCL: setDate -> e", e);
    setDataCompany({ ...dataCompany, finalDate: e });
  };

  useEffect(() => {
    fetchAPI();
  }, []);

  const fetchAPI = async () => {
    setDataCompany({ ...dataCompany, load: true });
    let status = await api.get(`/company-status`);
    const types = await api.get("/company-types");
    const companies = await api.get(`/companies`);
    const sectors = await api.get(`/sectors?status=1`);

    const data = await formatCompanies(companies);

    setDataCompany({
      ...dataCompany,
      companyStatus: status.data.rows,
      companyTypes: types.data.rows,
      companySectors: sectors.data.rows,
      companyData: data,
      load: false
    });
  };

  const formatCompanies = async (companies, status) => {
    return await companies.data.rows.map(item => {
      if (status != '&CompanyStatusId=1') {
        const sectors = item.Sectors.reduce((acc, curr) => {
          acc[curr.id] = `${curr.name} / `;
          return acc;
        }, []).filter(el => el != null);

        return {
          id: item.id,
          cnpj: item.cnpj,
          socialName: item.socialName,
          status: item.CompanyStatus.description,
          createdAt: moment.utc(item.createdAt).format("DD/MM/YYYY"),
          sectors: sectors
        }
      } else {
        return {
          id: item.id,
          cnpj: item.cnpj,
          socialName: item.socialName,
          status: item.CompanyStatus.description,
          createdAt: moment.utc(item.createdAt).format("DD/MM/YYYY")
        } 
      }
    });
  };

  const searchCompany = async () => {
    setDataCompany({ ...dataCompany, load: true });
    const { socialName, companyStatus, companyType, sector } = state;
    const { initialDate, finalDate } = dataCompany;
    const razao = socialName ? `&socialName=${socialName}` : "";
    const status = companyStatus ? `&CompanyStatusId=${companyStatus}` : "";
    const type = companyType ? `&companyTypeId=${companyType}` : "";
    const startDate = initialDate ? `&startDate=${initialDate}` : "";
    const fDate = finalDate ? `&finalDate=${finalDate}` : "";
    const setor = sector ? `&sectorReport=${sector}` : "";
    const response = await api.get(
      `/reports/companies?order_by=id&order_direction=DESC&page=1${razao}${status}${type}${startDate}${fDate}${setor}`
    );
   
    const formatedCompanies = await formatCompanies(response, status);

    setDataCompany({
      ...dataCompany,
      companyData: formatedCompanies,
      load: false
    });
  };

  const customPdfButton = () => {
    const title = "DPWCDI Report - Empresas";
    const fileName = `DPWCDI Report Empresas - ${moment().format(
      "DD/MM/YYYY"
    )}`;

    // Build date range subtitle if dates are provided
    let dateRangeText = "";
    if (dataCompany.initialDate || dataCompany.finalDate) {
      const startDate = dataCompany.initialDate ? moment(dataCompany.initialDate).format("DD/MM/YYYY") : "...";
      const endDate = dataCompany.finalDate ? moment(dataCompany.finalDate).format("DD/MM/YYYY") : "...";
      dateRangeText = `Período: ${startDate} - ${endDate}`;
    }

    const headers = [
      ["ID", "CNPJ", "Razão social", "Status", "Data cadastro", "Área gestora"]
    ];

    const data = dataCompany.companyData.map(item => [
      item.id,
      item.cnpj,
      item.socialName,
      item.status,
      item.createdAt,
      item.sectors.join()
    ]);

    const unit = "pt";
    const size = "A4"; // Use A1, A2, A3 or A4
    const orientation = "landscape"; // portrait or landscape

    const marginLeft = 40;
    const doc = new jsPDF(orientation, unit, size);

    doc.setFontSize(15);
    let currentY = 20;

    // Add title
    doc.text(title, marginLeft, currentY);
    currentY += 20;

    // Add date range if provided
    if (dateRangeText) {
      doc.setFontSize(12);
      doc.text(dateRangeText, marginLeft, currentY);
      currentY += 15;
    }

    let content = {
      startY: currentY + 10,
      head: headers,
      body: data
    };

    doc.autoTable(content);
    doc.save(fileName);
  };

  const exportToExcel = () => {
    // Create workbook
    const wb = XLSX.utils.book_new();
    
    // Prepare headers and data
    const headers = ['ID', 'CNPJ', 'Razão social', 'Status', 'Data de Cadastro', 'Área gestora'];
    const data = dataCompany.companyData.map(item => [
      item.id,
      item.cnpj,
      item.socialName,
      item.status,
      item.createdAt,
      Array.isArray(item.sectors) ? item.sectors.join(', ') : item.sectors
    ]);

    // Build date range text if dates are provided
    let dateRangeText = "";
    if (dataCompany.initialDate || dataCompany.finalDate) {
      const startDate = dataCompany.initialDate ? moment(dataCompany.initialDate).format("DD/MM/YYYY") : "...";
      const endDate = dataCompany.finalDate ? moment(dataCompany.finalDate).format("DD/MM/YYYY") : "...";
      dateRangeText = `Período: ${startDate} - ${endDate}`;
    }

    // Create worksheet structure with title and optional date range
    let worksheetData = [
      [], // Empty row
      ['DPWCDI Report - Empresas'], // Title
      [`Gerado em: ${moment().format('DD/MM/YYYY HH:mm')}`] // Generation date
    ];

    // Add date range if provided
    if (dateRangeText) {
      worksheetData.push([dateRangeText]);
    }

    // Add empty row and headers
    worksheetData.push([], headers, ...data);

    const ws = XLSX.utils.aoa_to_sheet(worksheetData);

    // Calculate merges based on whether date range is included
    const titleRowIndex = 1;
    const dateGenRowIndex = 2;
    const dateRangeRowIndex = dateRangeText ? 3 : -1;
    const headerRowIndex = dateRangeText ? 5 : 4;

    // Merge cells for title, generation date, and optional date range
    ws['!merges'] = [
      { s: { r: titleRowIndex, c: 0 }, e: { r: titleRowIndex, c: 5 } }, // Title spans columns A-F
      { s: { r: dateGenRowIndex, c: 0 }, e: { r: dateGenRowIndex, c: 5 } } // Generation date spans columns A-F
    ];

    // Add date range merge if it exists
    if (dateRangeText) {
      ws['!merges'].push({ s: { r: dateRangeRowIndex, c: 0 }, e: { r: dateRangeRowIndex, c: 5 } });
    }

    // Set column widths
    ws['!cols'] = [
      { wch: 8 },   // ID
      { wch: 18 },  // CNPJ
      { wch: 30 },  // Razão social
      { wch: 20 },  // Status
      { wch: 15 },  // Data de Cadastro
      { wch: 35 }   // Área gestora
    ];

    // Style header row with blue background and white text
    headers.forEach((header, index) => {
      const cellRef = XLSX.utils.encode_cell({ r: headerRowIndex, c: index });
      if (ws[cellRef]) {
        ws[cellRef].s = {
          font: { bold: true, color: { rgb: 'FFFFFF' } },
          fill: { fgColor: { rgb: '1e88e5' } }, // Your requested blue color
          alignment: { horizontal: 'center', vertical: 'center' }
        };
      }
    });

    // Add worksheet to workbook
    XLSX.utils.book_append_sheet(wb, ws, 'Empresas');

    // Generate filename with current date
    const fileName = `DPWCDI_Report_Empresas_${moment().format('DD-MM-YYYY')}.xlsx`;

    // Save file
    XLSX.writeFile(wb, fileName);
  };

  const tableIcons = {
    Export: forwardRef((props, ref) => (
      <Button
        size="small"
        className={"btn-info"}
        startIcon={<TableChart {...props} ref={ref} color="action" />}
        onClick={exportToExcel}
      >
        XLS
      </Button>
    ))
  }; 

  // const handleExportCsv = (toolbar, columns, renderData) => {
  //   const csvColumns = columns.filter(columnDef => {
  //     return !columnDef.hidden && columnDef.field && columnDef.export !== false;
  //   });

  //   const data = renderData.map(rowData =>
  //     csvColumns.map(columnDef => rowData[columnDef.field])
  //   );

  //   const builder = new CsvBuilder("foo" + ".csv")
  //     .setDelimeter(",")
  //     .setColumns(csvColumns.map(columnDef => columnDef.title))
  //     .addRows(data)
  //     .exportFile();

  //   toolbar.setState({ exportButtonAnchorEl: null }); // this is the reason to pass the m-table-toolbar object
  // };

  return (
    <Fragment>
      <div className="col-md-12">
        <h3 class="card-title mt-1">Filtros da empresa</h3>
        <hr />
        <div className="row mb-2 p-20">
          <div className="col-md-2">
            <DatePicker
              id="initialDate"
              data={dataCompany.initialDate}
              onChange={e => setInitialDate(e)}
              dateLabel="Data inicio"
            />
          </div>
          <div className="col-md-2">
            <DatePicker
              id="finalDate"
              data={dataCompany.finalDate}
              onChange={e => setFinalDate(e)}
              dateLabel="Data final"
            />
          </div>
          <div className="col-md-2">
            <MaterialSelect
              autoWidth
              name="companyType"
              dateLabel="Tipo de empresa"
              value={state.companyType}
              data={dataCompany.companyTypes}
              onChange={onChange}
            />
          </div>
          <div className="col-md-2">
            <MaterialSelect
              autoWidth
              name="companyStatus"
              dateLabel="Status"
              value={state.companyStatus}
              data={dataCompany.companyStatus}
              onChange={onChange}
            />
          </div>
          <div className="col-md-2">
            <TextField
              justify="space-around"
              name="socialName"
              label="Razão Social"
              onChange={onChange}
            />
          </div>
          <div className="col-md-2">
            <MaterialSelect
              name="sector"
              dateLabel="Área gestora"
              value={state.sector}
              data={dataCompany.companySectors}
              onChange={onChange}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-9"></div>
          <div className="col-md-3 ">
            <Button
              variant="contained"
              color="primary"
              size="small"
              className={"btn-info"}
              startIcon={<SearchIcon />}
              onClick={searchCompany}
            >
              Pesquisar
            </Button>
            <Button
              size="small"
              className={"btn-info"}
              startIcon={<PictureAsPdfTwoToneIcon />}
              onClick={customPdfButton}
              className={classes.pdf}
            >
              PDF
            </Button>
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="col-md-12 mt-1">
            <MaterialTable
              title=""
              icons={tableIcons}
              isLoading={dataCompany.load}
              localization={{
                pagination: {
                  labelDisplayedRows: "{from}-{to} de {count}",
                  labelRowsSelect: "linhas",
                  firstTooltip: "Primeira",
                  previousTooltip: "Anterior",
                  nextTooltip: "Próxima",
                  lastTooltip: "Última"
                },
                body: {
                  emptyDataSourceMessage: "Não há dados a serem exibidos",
                  editRow: {
                    saveTooltip: "Salvar",
                    cancelTooltip: "Cancelar",
                    deleteText: "Tem certeza que deseja deletar este registro?"
                  },
                  addTooltip: "Adicionar",
                  deleteTooltip: "Deletar",
                  editTooltip: "Editar"
                },
                header: {
                  actions: "Ações"
                },
                toolbar: {
                  nRowsSelected: "{0} linha(s) selecionada(s)",
                  searchPlaceholder: "Pesquisar",
                  exportTitle: "Exportar para Excel",
                  exportName: "Exportar para Excel"
                }
              }}
              columns={dataCompany.columns}
              options={{
                exportButton: true,
                exportAllData: true,
                exportCsv: (columns, renderData) => {
                  // Override default CSV export to use our Excel function
                  exportToExcel();
                }
              }}
              data={dataCompany.companyData}
            />
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default CompanyReport;
